import { render, staticRenderFns } from "./playVideo.vue?vue&type=template&id=f84c39b2&scoped=true&"
import script from "./playVideo.vue?vue&type=script&lang=js&"
export * from "./playVideo.vue?vue&type=script&lang=js&"
import style0 from "./playVideo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./playVideo.vue?vue&type=style&index=1&id=f84c39b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84c39b2",
  null
  
)

export default component.exports